export default __webpack_public_path__ + "static/media/sponsored_session.c17adfa1.png";